import React from 'react';
// components
import FormattedWeight from 'components/FormattedWeight';
// utils
import round from 'lodash.round';
// types
import { MeasurementSystemType } from 'types';

// imperial system - lbs, metric system - kg, on back-end always lbs

const kgInPounds = 0.45359237;

export function convertLbsToKg(lbsValue: number) {
  return round(lbsValue * kgInPounds);
}

export function convertKgToLbs(kgValue: number) {
  return round(kgValue / kgInPounds, 2);
}

export function formatBackEndWeightToSystem(
  lbsValue: number | string,
  measurementSystem: MeasurementSystemType
) {
  const numericValue = typeof lbsValue === 'string' ? parseFloat(lbsValue) : lbsValue;
  return measurementSystem === 'imperial' ? round(numericValue, 2) : convertLbsToKg(numericValue);
}

export function formatWeightToBackEndFormat(
  weightValue: number | string,
  currentMeasurementSystem: MeasurementSystemType
) {
  const numericValue = typeof weightValue === 'string' ? parseFloat(weightValue) : weightValue;
  return currentMeasurementSystem === 'imperial' ? numericValue : convertKgToLbs(numericValue);
}

export function addLabelToWeightValue(value?: string | number) {
  return value ? <FormattedWeight value={value} /> : '';
}
